











import Vue from 'vue'
import moment from 'moment'
import DataItem from '@/components/DataItem.vue'

export default Vue.extend({
  name: 'Archive',
  data() {
    return {
      currentItem: {},
      todayDateKey: moment().format('YYYYMMDD'),
      todayDate: moment().format('DD-MM-YYYY'),
      tomorrowDate: moment().add(1, 'days').format('DD-MM-YYYY')
    }
  },
  components: {
    DataItem
  },
  props: ['events', 'time']
});
